import { useState } from 'react';
import {
  Avatar,
  Box,
  Button,
  Typography,
  styled,
  useTheme
} from '@mui/material';
import { GridContainer, GridItem } from './Index';
import DefaultAvatar from 'src/assets/icons/DefaultAvatar.png';
import { filePaths } from 'src/utils/properties';
import DefaultProfileIcon from 'src/assets/icons/DefaultAvatar.png';

export const UserBoxButton = styled(Button)(({ theme }) => ({
  maxWidth: '100%',
  columnGap: '19px',
  [theme.breakpoints.up('xs')]: {
    marginRight: 0
  },
  [theme.breakpoints.up('md')]: {
    marginRight: theme.spacing(8)
  },
  [theme.breakpoints.up('lg')]: {
    marginRight: theme.spacing(9)
  },
  [theme.breakpoints.up('xl')]: {
    marginRight: theme.spacing(10)
  }
}));

export const HeaderParentProfileAvatar = (props) => {
  const theme = useTheme();

  const [imgSrc, setImgSrc] = useState(
    props.src === null || props.src === undefined
      ? filePaths.PARENT + props.src
      : DefaultProfileIcon
  );

  const handleError = () => {
    setImgSrc(DefaultProfileIcon);
  };

  return (
    <Avatar
      {...props}
      src={imgSrc}
      onError={handleError}
      variant="circular"
      sx={{
        border: '1px solid #FA7B17',
        background: '#FFE2BB'
      }}
    />
  );
};

export const HeaderProfileAvatar = (props) => {
  const theme = useTheme();

  const [imgSrc, setImgSrc] = useState(
    props.src === null || props.src === undefined
      ? filePaths.PARENT + props.src
      : DefaultProfileIcon
  );

  const handleError = () => {
    setImgSrc(DefaultProfileIcon);
  };

  return (
    <Avatar
      {...props}
      src={imgSrc}
      onError={handleError}
      variant="circular"
      sx={{
        border: '1px solid #FA7B17',
        background: '#FFE2BB'
      }}
    />
  );
};

const ParentHeaderProfileAvatar = styled((props: { src: any; sx?: any }) => {
  const theme = useTheme();

  const [imgSrc, setImgSrc] = useState(
    props.src === null || props.src === undefined
      ? DefaultProfileIcon
      : filePaths.PARENT + props.src
  );

  const handleError = () => {
    setImgSrc(DefaultProfileIcon);
  };

  return (
    <Avatar
      sx={{
        borderRadius: '4px',
        overflow: 'hidden',
        [theme.breakpoints.up('xs')]: { width: '96px', height: '107px' },
        [theme.breakpoints.up('sm')]: { width: '166px', height: '185px' },
        [theme.breakpoints.up('md')]: { width: '166px', height: '185px' }
      }}
      {...props}
    >
      <img
        src={imgSrc}
        onError={handleError}
        style={{
          height: '100%',
          width: '100%',
          objectFit: 'contain'
        }}
      />
    </Avatar>
  );
})({});

export const ProfileAvatar = styled(Avatar)(({ theme }) => ({
  '.MuiAvatar-fallback': {
    background: `url(${DefaultAvatar}) center no-repeat`,
    backgroundSize: '100% 100%',
    width: '100%',
    height: '100%',
    path: {
      display: 'none'
    }
  },
  border: '1px solid #FA7B17'
}));

export const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
`
);

export const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: 500;
        color:#343434;
`
);

export const ParentPopoverGridContainer = styled(GridContainer)(
  ({ theme }) => ({
    maxWidth: '300px',
    padding: '10px'
  })
);

export const ChildPopoverGridContainer1 = styled(GridContainer)(
  ({ theme }) => ({
    height: '136px'
  })
);

export const MyChildListGridItem = styled(GridItem)(({ theme }) => ({
  borderTop: '1px solid #F2F2F2',
  marginTop: '20px',
  backgroundColor: '#fafafa'
}));

export const ButtonText = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 400,
  color: '#fa7b17'
}));

export const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 10;
        background-color: ${theme.colors.alpha.trueWhite[100]};
        backdrop-filter: 0;
        position: fixed;
        justify-content: space-between;
        width: 100%;
        display: flex;
        align-items: center;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.08);

`
);

export { ParentHeaderProfileAvatar };
